__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_56_a12e1bc4/_next/";